// Ayurveda.jsx
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

// === IMAGES ===
// Use appropriate serene / Ayurvedic-themed images from your assets
import heroBg from '../assets/Mahi/112.jpeg';          // Hero: beach + palms or treatment ambiance
import ayurveda1 from '../assets/Mahi/116.jpeg';
import ayurveda2 from '../assets/Mahi/71.jpeg';
import ayurveda3 from '../assets/Mahi/22.jpeg';
import ayurveda4 from '../assets/Mahi/72.jpeg';
import ayurveda5 from '../assets/Mahi/74.jpeg';

// === TREATMENT IMAGES ===
import shirodharaImg from '../assets/Mahi/7.jpeg';
import steamBathImg from '../assets/Mahi/73.jpeg';
import flowerBathImg from '../assets/Mahi/70.jpeg';
import headMassageImg from '../assets/Mahi/118.jpeg';
import faceMassageImg from '../assets/Mahi/120.jpg';
import neckMassageImg from '../assets/Mahi/121.jpg';
import shoulderMassageImg from '../assets/Mahi/122.jpg';
import bodyMassageImg from '../assets/Mahi/123.jpeg';
import backMassageImg from '../assets/Mahi/128.jpg';
import footMassageImg from '../assets/Mahi/22.jpeg';
import purgativeImg from '../assets/Mahi/129.avif';
import nasalClearingImg from '../assets/Mahi/130.jpg';
import powderMassageImg from '../assets/Ayurveda/77.webp';
import akkupancharImg from '../assets/Mahi/131.jpg';

// === NEW TREATMENT IMAGES ===
import intensiveMassageImg from '../assets/Ayurveda/80.jpg';
import thermoMassageImg from '../assets/Ayurveda/81.jpg';
import synchronMassageImg from '../assets/Ayurveda/82.jpg';
import specialMassageImg from '../assets/Ayurveda/83.jpg';

import benefitsImg from '../assets/Mahi/123.jpeg'; // Image for Benefits section

// === DOCTOR IMAGES ===
import drSandyaImg from '../assets/Mahi/3.jpeg';
import drPandukaImg from '../assets/Mahi/144.jpeg';



const ayurvedaImages = [
    { src: ayurveda1, altKey: 'ayurveda1' },
    { src: ayurveda2, altKey: 'ayurveda2' },
    { src: ayurveda3, altKey: 'ayurveda3' },
    { src: ayurveda4, altKey: 'ayurveda4' },
    { src: ayurveda5, altKey: 'ayurveda5' },
];


// === MOTION VARIANTS ===






const Ayurveda = () => {
    const { t } = useTranslation('ayurveda');

    // Intro paragraphs (can move to i18n files later)
    const [activeIndex, setActiveIndex] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);



    const toggleService = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };
    const dataArray = [
        {
            title: t('accordionTitle1'),
            desc: t('accordionDesc1')
        },
        {
            title: t('accordionTitle2'),
            desc: t('accordionDesc2')
        },
        {
            title: t('accordionTitle3'),
            desc: t('accordionDesc3')
        },
        {
            title: t('accordionTitle4'),
            desc: t('accordionDesc4')
        },
        {
            title: t('accordionTitle5'),
            desc: t('accordionDesc5')
        }
    ];

    const ayurvedaSliderSettings = {
        dots: false,
        infinite: true,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: false,

        customPaging: () => (
            <div className="w-3 h-3 rounded-full bg-[#0D4E4A] hover:bg-[#E4AB58] transition"></div>
        ),
    };

    const treatments = {
        shirodhara: {
            name: t('shirodhara'),
            description: t('shirodharaDesc'),
            benefits: [
                t('shirodhara1'),
                t('shirodhara2'),
                t('shirodhara3'),
            ],
            image: shirodharaImg,
        },
        steamBath: {
            name: t('steamBath'),
            description: t('steamBathDesc'),
            benefits: [
                t('steamBath1'),
                t('steamBath2'),
                t('steamBath3'),
            ],
            image: steamBathImg,
        },
        flowerBath: {
            name: t('flowerBath'),
            description: t('flowerBathDesc'),
            benefits: [
                t('flowerBath1'),
                t('flowerBath2'),
                t('flowerBath3'),
            ],
            image: flowerBathImg,
        },
        headMassage: {
            name: t('headMassage'),
            description: t('headMassageDesc'),
            benefits: [
                t('headMassage1'),
                t('headMassage2'),
                t('headMassage3'),
            ],
            image: headMassageImg,
        },
        faceMassage: {
            name: t('faceMassage'),
            description: t('faceMassageDesc'),
            benefits: [
                t('faceMassage1'),
                t('faceMassage2'),
                t('faceMassage3'),
            ],
            image: faceMassageImg,
        },
        neckMassage: {
            name: t('neckMassage'),
            description: t('neckMassageDesc'),
            benefits: [
                t('neckMassage1'),
                t('neckMassage2'),
                t('neckMassage3'),
            ],
            image: neckMassageImg,
        },
        shoulderMassage: {
            name: t('shoulderMassage'),
            description: t('shoulderMassageDesc'),
            benefits: [
                t('shoulderMassage1'),
                t('shoulderMassage2'),
                t('shoulderMassage3'),
            ],
            image: shoulderMassageImg,
        },
        bodyMassage: {
            name: t('bodyMassage'),
            description: t('bodyMassageDesc'),
            benefits: [
                t('bodyMassage1'),
                t('bodyMassage2'),
                t('bodyMassage3'),
            ],
            image: bodyMassageImg,
        },
        backMassage: {
            name: t('backMassage'),
            description: t('backMassageDesc'),
            benefits: [
                t('backMassage1'),
                t('backMassage2'),
                t('backMassage3'),
            ],
            image: backMassageImg,
        },
        footMassage: {
            name: t('footMassage'),
            description: t('footMassageDesc'),
            benefits: [
                t('footMassage1'),
                t('footMassage2'),
                t('footMassage3'),
            ],
            image: footMassageImg,
        },
        purgative: {
            name: t('purgative'),
            description: t('purgativeDesc'),
            benefits: [
                t('purgative1'),
                t('purgative2'),
                t('purgative3'),
            ],
            image: purgativeImg,
        },
        nasalClearing: {
            name: t('nasalClearing'),
            description: t('nasalClearingDesc'),
            benefits: [
                t('nasalClearing1'),
                t('nasalClearing2'),
                t('nasalClearing3'),
            ],
            image: nasalClearingImg,
        },
        powderMassage: {
            name: t('powderMassage'),
            description: t('powderMassageDesc'),
            benefits: [
                t('powderMassage1'),
                t('powderMassage2'),
                t('powderMassage3'),
            ],
            image: powderMassageImg,
        },
        intensiveMassage: {
            name: t('intensiveMassage'),
            description: t('intensiveMassageDesc'),
            benefits: [
                t('intensiveMassage1'),
                t('intensiveMassage2'),
                t('intensiveMassage3'),
            ],
            image: intensiveMassageImg,
        },
        thermoMassage: {
            name: t('thermoMassage'),
            description: t('thermoMassageDesc'),
            benefits: [
                t('thermoMassage1'),
                t('thermoMassage2'),
                t('thermoMassage3'),
            ],
            image: thermoMassageImg,
        },
        synchronMassage: {
            name: t('synchronMassage'),
            description: t('synchronMassageDesc'),
            benefits: [
                t('synchronMassage1'),
                t('synchronMassage2'),
                t('synchronMassage3'),
            ],
            image: synchronMassageImg,
        },
        specialMassage: {
            name: t('specialMassage'),
            description: t('specialMassageDesc'),
            benefits: [
                t('specialMassage1'),
                t('specialMassage2'),
                t('specialMassage3'),
            ],
            image: specialMassageImg,
        },
    };

    const treatmentsArray = Object.values(treatments);
    const benefitsDetails = [
        <>
            <span style={{ color: '#E4AB58' }}>{t('benefit1Title')}</span> {t('benefit1Desc')}
        </>,
        <>
            <span style={{ color: '#E4AB58' }}>{t('benefit2Title')}</span> {t('benefit2Desc')}
        </>,
        <>
            <span style={{ color: '#E4AB58' }}>{t('benefit3Title')}</span> {t('benefit3Desc')}
        </>,
        <>
            <span style={{ color: '#E4AB58' }}>{t('benefit4Title')}</span> {t('benefit4Desc')}
        </>,
        <>
            <span style={{ color: '#E4AB58' }}>{t('benefit5Title')}</span> {t('benefit5Desc')}
        </>,
        <>
            <span style={{ color: '#E4AB58' }}>{t('benefit6Title')}</span> {t('benefit6Desc')}
        </>,
    ];






    return (
        <div className="bg-[#E0DAC0] min-h-screen">
            {/* ===== HERO SECTION ===== */}
            <motion.div
                initial="hidden"
                animate="visible"
                variants={{
                    hidden: { opacity: 0 },
                    visible: { opacity: 1, transition: { duration: 0.8 } }
                }}
                className="relative h-[70vh] min-h-[520px] flex items-center justify-center overflow-hidden"
            >
                {/* Background Image + subtle scale animation */}
                <motion.img
                    src={heroBg}
                    alt={t('heroAlt') || "Ayurveda & Wellness at Muthumuni Beach Resort"}
                    className="absolute inset-0 h-full w-full object-cover brightness-[0.68] scale-[1.03]"
                    initial={{ scale: 1.05 }}
                    animate={{ scale: 1.03 }}
                    transition={{ duration: 18, repeat: Infinity, repeatType: "reverse", ease: "easeInOut" }}
                />

                {/* Stronger, more elegant overlay gradient */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/45 to-black/60" />

                {/* Content */}
                <motion.div
                    variants={{
                        hidden: { opacity: 0, y: 40 },
                        visible: { opacity: 1, y: 0, transition: { delay: 0.4, duration: 1, ease: "easeOut" } }
                    }}
                    className="relative z-10 text-center px-5 sm:px-8 md:px-12 max-w-5xl"
                >
                    {/* Optional elegant eyebrow with lines */}
                    <div className="inline-flex items-center gap-6 md:gap-8 mb-6 md:mb-8">
                        <div className="h-px w-12 md:w-20 bg-amber-400/50 flex-1" />
                        <span className="
        text-amber-300 uppercase tracking-[0.35em] md:tracking-[0.5em]
        text-xs sm:text-sm md:text-base font-medium
      ">
                            {t('heroEyebrow') || 'Muthumuni Beach Resort'}
                        </span>
                        <div className="h-px w-12 md:w-20 bg-amber-400/50 flex-1" />
                    </div>

                    {/* Main Title – dramatic scale + shadow */}
                    <h1 className="
      text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl
      font-serif font-light tracking-tight leading-tight
      text-white drop-shadow-[0_5px_18px_rgba(0,0,0,0.8)]
    ">
                        {t('heroTitle')}
                    </h1>

                    {/* Subtitle – elegant accent color */}
                    <p className="
      mt-5 sm:mt-7 md:mt-9
      text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl
      font-medium text-amber-200/95 tracking-wide
      drop-shadow-md max-w-4xl mx-auto leading-relaxed
    ">
                        {t('heroSubtitle')}
                    </p>

                    {/* Optional small CTA or decorative element */}
                    {t('heroTagline') && (
                        <p className="
        mt-8 text-base sm:text-lg md:text-xl
        text-white/80 italic font-light max-w-3xl mx-auto
      ">
                            {t('heroTagline')}
                        </p>
                    )}
                </motion.div>

                {/* Optional subtle scroll indicator (bottom center) */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 0.7, y: 0 }}
                    transition={{ delay: 1.8, duration: 1.2 }}
                    className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:flex flex-col items-center gap-2"
                >
                    <div className="w-6 h-10 border-2 border-white/60 rounded-full flex items-center justify-center">
                        <motion.div
                            animate={{ y: [0, 12, 0] }}
                            transition={{ repeat: Infinity, duration: 1.8, ease: "easeInOut" }}
                            className="w-1.5 h-3 bg-white/80 rounded-full"
                        />
                    </div>
                    <span className="text-white/70 text-xs tracking-wider uppercase">
                        Scroll
                    </span>
                </motion.div>
            </motion.div>

            {/* ===== AYURVEDA & WELLNESS SECTION ===== */}
            <section className="relative bg-gradient-to-b from-[#f9f7f0] via-[#f5f2e8] to-[#e8e4d6] py-16 md:py-24 lg:py-32 overflow-hidden">
                {/* Subtle decorative background */}
                <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute top-0 right-0 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl" />
                    <div className="absolute bottom-0 left-0 w-96 h-96 bg-teal-600/5 rounded-full blur-3xl" />
                </div>

                <div className="relative container mx-auto px-5 sm:px-8 lg:px-12">
                    {/* Header */}
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, margin: "-80px" }}
                        variants={{
                            hidden: { opacity: 0, y: 40 },
                            visible: { opacity: 1, y: 0, transition: { duration: 0.9, ease: "easeOut" } }
                        }}
                        className="text-center mb-14 md:mb-20"
                    >
                        <span className="inline-block text-amber-600 uppercase tracking-[0.35em] text-sm md:text-base font-medium mb-4">
                            {t('sectionEyebrow')}
                        </span>

                        <h2 className="
        text-3xl sm:text-4xl md:text-5xl lg:text-6xl
        font-serif font-light text-teal-950 tracking-tight
      ">
                            Authentic <span className="text-amber-600">Ayurvedic</span> Wellness
                        </h2>

                        <div className="h-1 w-20 md:w-28 mx-auto mt-6 bg-gradient-to-r from-amber-500 to-teal-700 rounded-full" />

                        <p className="
        mt-6 text-lg md:text-xl text-teal-800/85 max-w-3xl mx-auto leading-relaxed
      ">
                            {t('sectionDescription')}
                        </p>
                    </motion.div>

                    <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
                        {/* Left: Image Slider (now 5/12 on desktop) */}
                        <motion.div
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, margin: "-100px" }}
                            variants={{
                                hidden: { opacity: 0, x: -40 },
                                visible: { opacity: 1, x: 0, transition: { duration: 1, ease: "easeOut" } }
                            }}
                            className="lg:col-span-5 relative  overflow-hidden "
                        >
                            <div className="aspect-[4/5] md:aspect-[3/4] lg:aspect-[4/5]">
                                <Slider {...ayurvedaSliderSettings}>
                                    {ayurvedaImages.map((image, index) => (
                                        <div key={index} className="h-full relative group">
                                            <img
                                                src={image.src}
                                                alt={t(`kandy.images.${image.altKey}`) || "Ayurveda treatment"}
                                                className="
                    h-full w-full object-cover  
                  "
                                                onError={(e) => {
                                                    e.target.src = 'https://via.placeholder.com/600x800?text=Image+Not+Found';
                                                }}
                                            />
                                            <div className="
                  absolute inset-0 
                  opacity-0 group-hover:opacity-100 transition-opacity duration-700
                " />
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </motion.div>

                        {/* Right: Services Accordion (now 7/12 on desktop) */}
                        <motion.div
                            variants={{
                                hidden: { opacity: 0 },
                                visible: {
                                    opacity: 1,
                                    transition: { staggerChildren: 0.12, delayChildren: 0.3 }
                                }
                            }}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, margin: "-100px" }}
                            className="lg:col-span-7 space-y-4 md:space-y-5"
                        >
                            {dataArray.map((item, index) => (
                                <motion.div
                                    key={index}
                                    custom={index}
                                    variants={{
                                        hidden: { opacity: 0, y: 25 },
                                        visible: i => ({
                                            opacity: 1,
                                            y: 0,
                                            transition: { delay: i * 0.08, duration: 0.6, ease: "easeOut" }
                                        })
                                    }}
                                    className={`
              rounded-xl md:rounded-2xl overflow-hidden
              border border-teal-100/70 bg-white/70 backdrop-blur-sm
              shadow-md hover:shadow-xl transition-all duration-300
              ${activeIndex === index ? 'border-amber-500/60 shadow-amber-500/20' : ''}
            `}
                                >
                                    <button
                                        onClick={() => toggleService(index)}
                                        className="w-full px-6 py-5 md:px-8 md:py-6 text-left flex items-center justify-between group focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-offset-2"
                                        aria-expanded={activeIndex === index}
                                        aria-controls={`service-content-${index}`}
                                    >
                                        <h3 className="
                text-lg md:text-xl lg:text-2xl font-medium
                text-teal-950 group-hover:text-amber-700 transition-colors
              ">
                                            {item.title}
                                        </h3>

                                        <span className={`
                text-2xl md:text-3xl font-light transition-transform duration-300
                ${activeIndex === index ? 'text-amber-600 rotate-180' : 'text-teal-600'}
              `}>
                                            {activeIndex === index ? '−' : '+'}
                                        </span>
                                    </button>

                                    <motion.div
                                        id={`service-content-${index}`}
                                        initial={false}
                                        animate={{ height: activeIndex === index ? "auto" : 0 }}
                                        transition={{ duration: 0.4, ease: [0.04, 0.62, 0.23, 0.98] }}
                                        className="overflow-hidden"
                                    >
                                        <div className="px-6 pb-6 md:px-8 md:pb-8 pt-1">
                                            <p className="text-base md:text-lg text-teal-800/90 leading-relaxed whitespace-pre-line">
                                                {item.desc}
                                            </p>
                                        </div>
                                    </motion.div>
                                </motion.div>
                            ))}
                        </motion.div>
                    </div>
                </div>
            </section>

            {/* ================= TREATMENTS SECTION ================= */}
            <section className="relative py-16 md:py-24 lg:py-32 bg-gradient-to-b from-[#f9f7f0] via-[#f5f2e8] to-[#e8e4d6] overflow-hidden">
                {/* Subtle decorative background orbs */}
                <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute top-20 right-10 w-64 h-64 md:w-96 md:h-96 bg-amber-500/5 rounded-full blur-3xl" />
                    <div className="absolute bottom-10 left-10 w-64 h-64 md:w-96 md:h-96 bg-teal-600/5 rounded-full blur-3xl" />
                </div>

                <div className="relative container mx-auto px-5 sm:px-8 lg:px-12">
                    {/* Section Header */}
                    <div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, margin: "-80px" }}
                        variants={{
                            hidden: { opacity: 0, y: 40 },
                            visible: { opacity: 1, y: 0, transition: { duration: 0.9, ease: "easeOut" } }
                        }}
                        className="text-center mb-14 md:mb-20"
                    >
                        <span className="
        inline-block text-amber-600 uppercase tracking-[0.35em] md:tracking-[0.5em]
        text-sm md:text-base font-medium mb-4
      ">
                            {t('treatmentsEyebrow') || 'Signature Treatments'}
                        </span>

                        <h2 className="
        text-3xl sm:text-4xl md:text-5xl lg:text-6xl
        font-serif font-light text-teal-950 tracking-tight
      ">
                            {t('treatmentsTitle')}
                        </h2>

                        <div className="h-1 w-20 md:w-28 mx-auto mt-6 bg-gradient-to-r from-amber-500 to-teal-700 rounded-full" />

                        <p className="
        mt-6 text-lg md:text-xl text-teal-800/85 max-w-3xl mx-auto leading-relaxed
      ">
                            {t('treatmentsSubtitle')}
                        </p>
                    </div>

                    {/* Treatments Grid */}
                    <div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, margin: "-100px" }}
                        variants={{
                            hidden: { opacity: 0 },
                            visible: {
                                opacity: 1,
                                transition: { staggerChildren: 0.12, delayChildren: 0.2 }
                            }
                        }}
                        className="
        grid gap-6 sm:gap-8 md:gap-10
        grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4
      "
                    >
                        {treatmentsArray.map((treatment, index) => (
                            <motion.div
                                key={treatment.name}
                                custom={index}
                                variants={{
                                    hidden: { opacity: 0, y: 30, scale: 0.96 },
                                    visible: i => ({
                                        opacity: 1,
                                        y: 0,
                                        scale: 1,
                                        transition: { delay: i * 0.08, duration: 0.7, ease: "easeOut" }
                                    })
                                }}
                                className="
            group relative overflow-hidden rounded-2xl md:rounded-3xl
            bg-white/80 backdrop-blur-sm border border-teal-100/70
            shadow-lg hover:shadow-2xl hover:shadow-amber-500/15
            transition-all duration-500 hover:-translate-y-2
            flex flex-col h-full
          "
                            >
                                {/* Image */}
                                <div className="relative aspect-[4/3] overflow-hidden">
                                    <img
                                        src={treatment.image}
                                        alt={treatment.name}
                                        className="
                w-full h-full object-cover transition-transform duration-1000
                group-hover:scale-110
              "
                                        loading="lazy"
                                    />
                                    <div className="
              absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent
              opacity-0 group-hover:opacity-100 transition-opacity duration-700
            " />
                                </div>

                                {/* Content */}
                                <div className="p-6 md:p-7 lg:p-8 flex flex-col flex-grow">
                                    <h3 className="
              text-xl md:text-2xl lg:text-3xl font-medium
              text-teal-950 group-hover:text-amber-700
              transition-colors duration-300 mb-4
            ">
                                        {treatment.name}
                                    </h3>

                                    <p className="
              text-base md:text-lg text-teal-800/85 leading-relaxed
              mb-6 flex-grow
            ">
                                        {treatment.description}
                                    </p>

                                    {/* Benefits List */}
                                    <ul className="space-y-2.5 mb-8">
                                        {treatment.benefits.map((benefit, i) => (
                                            <li key={i} className="flex items-start gap-3 text-teal-800/90">
                                                <span className="text-amber-500 text-xl mt-0.5">•</span>
                                                <span className="text-base md:text-lg">{benefit}</span>
                                            </li>
                                        ))}
                                    </ul>

                                    {/* CTA Button */}
                                    <button
                                        className="
                mt-auto w-full py-4 rounded-full
                bg-gradient-to-r from-amber-500 to-amber-600
                hover:from-amber-600 hover:to-amber-700
                text-white font-semibold text-base md:text-lg
                shadow-lg hover:shadow-xl transform hover:-translate-y-1
                transition-all duration-300
              "
                                    >
                                        {t('bookTreatment') || 'Book This Treatment'}
                                    </button>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ===== Benefits of Panchakarma Treatments===== */}
            <motion.section
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: "-80px" }}
                variants={{
                    hidden: { opacity: 0 },
                    visible: {
                        opacity: 1,
                        transition: { staggerChildren: 0.15, delayChildren: 0.2 }
                    }
                }}
                className="relative py-16 md:py-24 lg:py-32 bg-gradient-to-b from-[#f9f7f0] via-[#f5f2e8] to-[#e8e4d6] overflow-hidden"
            >
                {/* Decorative background glows */}
                <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute top-20 right-10 w-64 h-64 md:w-96 md:h-96 bg-amber-500/5 rounded-full blur-3xl" />
                    <div className="absolute bottom-10 left-10 w-64 h-64 md:w-96 md:h-96 bg-teal-600/5 rounded-full blur-3xl" />
                </div>

                <div className="relative container mx-auto px-5 sm:px-8 lg:px-12">
                    {/* Section Title */}
                    <motion.div
                        variants={{
                            hidden: { opacity: 0, y: 40 },
                            visible: { opacity: 1, y: 0, transition: { duration: 0.9, ease: "easeOut" } }
                        }}
                        className="text-center mb-14 md:mb-20"
                    >
                        <span className="
        inline-block text-amber-600 uppercase tracking-[0.35em] md:tracking-[0.5em]
        text-sm md:text-base font-medium mb-4
      ">
                            {t('benefitsEyebrow') || 'Why Choose Panchakarma?'}
                        </span>

                        <h2 className="
        text-3xl sm:text-4xl md:text-5xl lg:text-6xl
        font-serif font-light text-teal-950 tracking-tight
      ">
                            {t('benefitsTitle')}
                        </h2>

                        <div className="h-1 w-20 md:w-28 mx-auto mt-6 bg-gradient-to-r from-amber-500 to-teal-700 rounded-full" />
                    </motion.div>

                    <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
                        {/* Image – Left on desktop, top on mobile */}
                        <motion.div
                            variants={{
                                hidden: { opacity: 0, x: -40 },
                                visible: { opacity: 1, x: 0, transition: { duration: 1, ease: "easeOut" } }
                            }}
                            className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl border border-teal-100/60 order-2 lg:order-1"
                        >
                            <div className="aspect-[4/3] md:aspect-[5/4] lg:aspect-[4/3] group">
                                <img
                                    src={benefitsImg}
                                    alt={t('benefitsImageAlt') || "Benefits of Panchakarma Treatments"}
                                    className="
              w-full h-full object-cover transition-transform duration-1000
              group-hover:scale-110
            "
                                    loading="lazy"
                                />
                                <div className="
            absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent
            opacity-0 group-hover:opacity-100 transition-opacity duration-700
          " />
                            </div>
                        </motion.div>

                        {/* Benefits List – Right on desktop, bottom on mobile */}
                        <motion.div
                            variants={{
                                hidden: { opacity: 0 },
                                visible: {
                                    opacity: 1,
                                    transition: { staggerChildren: 0.14, delayChildren: 0.3 }
                                }
                            }}
                            className="space-y-6 md:space-y-8 order-1 lg:order-2"
                        >
                            {benefitsDetails.map((point, index) => (
                                <motion.div
                                    key={index}
                                    custom={index}
                                    variants={{
                                        hidden: { opacity: 0, y: 25 },
                                        visible: i => ({
                                            opacity: 1,
                                            y: 0,
                                            transition: { delay: i * 0.1, duration: 0.7, ease: "easeOut" }
                                        })
                                    }}
                                    className="
              flex gap-5 p-6 md:p-7 rounded-xl bg-white/70 backdrop-blur-sm
              border border-teal-100 hover:border-amber-300 hover:shadow-lg
              transition-all duration-300
            "
                                >
                                    <div className="
              flex-shrink-0 w-12 h-12 rounded-full
              bg-gradient-to-br from-amber-500 to-amber-700
              flex items-center justify-center text-white font-bold text-xl
            ">
                                        {index + 1}
                                    </div>

                                    <p className="text-base md:text-lg lg:text-xl text-teal-800/90 leading-relaxed pt-1.5">
                                        {point}
                                    </p>
                                </motion.div>
                            ))}
                        </motion.div>
                    </div>
                </div>
            </motion.section>
            {/* ===== AKKUPANCHAR SECTION ===== */}
            <motion.section
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: "-80px" }}
                variants={{
                    hidden: { opacity: 0 },
                    visible: {
                        opacity: 1,
                        transition: { staggerChildren: 0.18, delayChildren: 0.3 }
                    }
                }}
                className="relative py-16 md:py-24 lg:py-32 bg-gradient-to-b from-[#f9f7f0] via-[#f5f2e8] to-[#e8e4d6] overflow-hidden"
            >
                {/* Decorative background glows */}
                <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute top-20 right-10 w-64 h-64 md:w-96 md:h-96 bg-amber-500/5 rounded-full blur-3xl" />
                    <div className="absolute bottom-10 left-10 w-64 h-64 md:w-96 md:h-96 bg-teal-600/5 rounded-full blur-3xl" />
                </div>

                <div className="relative container mx-auto px-5 sm:px-8 lg:px-12">
                    {/* Section Header */}
                    <motion.div
                        variants={{
                            hidden: { opacity: 0, y: 40 },
                            visible: { opacity: 1, y: 0, transition: { duration: 0.9, ease: "easeOut" } }
                        }}
                        className="text-center mb-14 md:mb-20"
                    >
                        <span className="
        inline-block text-amber-600 uppercase tracking-[0.35em] md:tracking-[0.5em]
        text-sm md:text-base font-medium mb-4
      ">
                            {t('therapyEyebrow') || 'Traditional Healing Art'}
                        </span>

                        <h2 className="
        text-3xl sm:text-4xl md:text-5xl lg:text-6xl
        font-serif font-light text-teal-950 tracking-tight
      ">
                            {t('akkupancharTitle')}
                        </h2>

                        <div className="h-1 w-20 md:w-28 mx-auto mt-6 bg-gradient-to-r from-amber-500 to-teal-700 rounded-full" />
                    </motion.div>

                    <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
                        {/* Text Content – Left on desktop, bottom on mobile */}
                        <motion.div
                            variants={{
                                hidden: { opacity: 0, x: -50 },
                                visible: { opacity: 1, x: 0, transition: { duration: 1, ease: "easeOut" } }
                            }}
                            className="space-y-8 md:space-y-10 order-2 lg:order-1"
                        >
                            <motion.p
                                variants={{
                                    hidden: { opacity: 0, y: 25 },
                                    visible: { opacity: 1, y: 0, transition: { delay: 0.2, duration: 0.8 } }
                                }}
                                className="text-lg md:text-xl lg:text-2xl text-teal-800/90 leading-relaxed font-light"
                            >
                                <span className="text-amber-600 font-semibold">{t('akkupanchar')}</span>{' '}
                                {t('akkupancharDesc1')}
                            </motion.p>

                            <motion.p
                                variants={{
                                    hidden: { opacity: 0, y: 25 },
                                    visible: { opacity: 1, y: 0, transition: { delay: 0.35, duration: 0.8 } }
                                }}
                                className="text-lg md:text-xl lg:text-2xl text-teal-800/90 leading-relaxed font-light"
                            >
                                <span className="text-amber-600 font-semibold">{t('akkupancharBenefit')}</span>{' '}
                                {t('akkupancharDesc2')}
                            </motion.p>

                            <motion.p
                                variants={{
                                    hidden: { opacity: 0, y: 25 },
                                    visible: { opacity: 1, y: 0, transition: { delay: 0.5, duration: 0.8 } }
                                }}
                                className="text-lg md:text-xl lg:text-2xl text-teal-800/90 leading-relaxed font-light"
                            >
                                <span className="text-amber-600 font-semibold">{t('akkupancharApplication')}</span>{' '}
                                {t('akkupancharDesc3')}
                            </motion.p>

                            <motion.p
                                variants={{
                                    hidden: { opacity: 0, y: 25 },
                                    visible: { opacity: 1, y: 0, transition: { delay: 0.65, duration: 0.8 } }
                                }}
                                className="text-lg md:text-xl lg:text-2xl text-teal-800/90 leading-relaxed font-light italic border-l-4 border-amber-500 pl-5 py-1"
                            >
                                <span className="text-amber-600 font-semibold not-italic">{t('akkupancharTransform')}</span>{' '}
                                {t('akkupancharDesc4')}
                            </motion.p>

                            {/* Optional CTA */}
                            <motion.div
                                variants={{
                                    hidden: { opacity: 0, y: 30 },
                                    visible: { opacity: 1, y: 0, transition: { delay: 0.8, duration: 0.7 } }
                                }}
                                className="pt-4"
                            >
                                <a
                                    href="/contact-us"
                                    className="
              inline-flex items-center gap-3 px-8 py-4 rounded-full
              bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700
              text-white font-medium text-lg shadow-lg hover:shadow-xl
              transform hover:-translate-y-1 transition-all duration-300
            "
                                >
                                    {t('experienceAkkupanchar') || 'Experience Akkupanchar Today'}
                                    <span aria-hidden>→</span>
                                </a>
                            </motion.div>
                        </motion.div>

                        {/* Image – Right on desktop, top on mobile */}
                        <motion.div
                            variants={{
                                hidden: { opacity: 0, x: 50 },
                                visible: { opacity: 1, x: 0, transition: { duration: 1, ease: "easeOut" } }
                            }}
                            className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl border border-teal-100/60 order-1 lg:order-2 group"
                        >
                            <div className="aspect-[4/3] md:aspect-[5/4] lg:aspect-[4/3]">
                                <img
                                    src={akkupancharImg}
                                    alt={t('akkupancharImageAlt') || "Akkupanchar Therapy at Muthumuni Ayurveda Beach Resort"}
                                    className="
              w-full h-full object-cover transition-transform duration-1000
              group-hover:scale-110
            "
                                    loading="lazy"
                                />
                                <div className="
            absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent
            opacity-60 group-hover:opacity-80 transition-opacity duration-700
          " />
                                <div className="absolute bottom-6 left-6 text-white">
                                    <p className="text-xl md:text-2xl font-semibold">
                                        {t('traditionalHealing') || 'Traditional Healing Art'}
                                    </p>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </div>
            </motion.section>

            {/* ===== OUR DOCTORS SECTION ===== */}
            <motion.section
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: "-80px" }}
                variants={{
                    hidden: { opacity: 0 },
                    visible: {
                        opacity: 1,
                        transition: { staggerChildren: 0.18, delayChildren: 0.3 }
                    }
                }}
                className="relative py-16 md:py-24 lg:py-32 bg-gradient-to-br from-teal-50 via-white to-amber-50 overflow-hidden"
            >
                {/* Decorative background elements */}
                <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute top-10 left-10 w-80 h-80 bg-amber-500/5 rounded-full blur-3xl" />
                    <div className="absolute bottom-20 right-10 w-96 h-96 bg-teal-600/5 rounded-full blur-3xl" />
                </div>

                <div className="relative container mx-auto px-5 sm:px-8 lg:px-12">
                    {/* Section Header */}
                    <motion.div
                        variants={{
                            hidden: { opacity: 0, y: 40 },
                            visible: { opacity: 1, y: 0, transition: { duration: 0.9, ease: "easeOut" } }
                        }}
                        className="text-center mb-14 md:mb-20"
                    >
                        <span className="inline-block text-amber-600 uppercase tracking-[0.35em] md:tracking-[0.5em] text-sm md:text-base font-medium mb-4">
                            {t('doctorsEyebrow')}
                        </span>
                        <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-serif font-light text-teal-950 tracking-tight">
                            {t('doctorsSectionTitle')}
                        </h2>
                    </motion.div>

                    {/* Doctors Grid */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 lg:gap-16">

                        {/* Dr. Sandya Mendis Card */}
                        <motion.div
                            variants={{
                                hidden: { opacity: 0, y: 50 },
                                visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
                            }}
                            className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500"
                        >
                            {/* Doctor Image */}
                            <div className="relative h-96 md:h-96 lg:h-[28rem] xl:h-[32rem] overflow-hidden">
                                <img
                                    src={drSandyaImg}
                                    alt={t('drSandyaName')}
                                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-teal-950/80 via-transparent to-transparent" />
                                <div className="absolute bottom-6 left-6 text-white">
                                    <h3 className="text-2xl md:text-3xl font-serif font-semibold mb-1">
                                        {t('drSandyaName')}
                                    </h3>
                                    <p className="text-amber-200 text-lg md:text-xl">
                                        {t('drSandyaProfession')}
                                    </p>
                                </div>
                            </div>

                            {/* Doctor Details */}
                            <div className="p-6 md:p-8 space-y-6">
                                {/* Specialization */}
                                <div>
                                    <h4 className="text-sm uppercase tracking-wider font-semibold text-amber-600 mb-2">
                                        Specialization
                                    </h4>
                                    <p className="text-teal-900 text-base md:text-lg leading-relaxed">
                                        {t('drSandyaSpecialization')}
                                    </p>
                                </div>

                                {/* Professional Profile */}
                                <div>
                                    <h4 className="text-sm uppercase tracking-wider font-semibold text-amber-600 mb-2">
                                        {t('drSandyaProfileTitle')}
                                    </h4>
                                    <p className="text-teal-900/80 text-base leading-relaxed">
                                        {t('drSandyaProfile')}
                                    </p>
                                </div>

                                {/* Work Experience */}
                                <div>
                                    <h4 className="text-sm uppercase tracking-wider font-semibold text-amber-600 mb-3">
                                        {t('drSandyaWorkExpTitle')}
                                    </h4>
                                    <ul className="space-y-2">
                                        <li className="flex items-start">
                                            <span className="inline-block w-2 h-2 bg-amber-500 rounded-full mt-2 mr-3 flex-shrink-0" />
                                            <span className="text-teal-900/80 text-sm md:text-base">
                                                {t('drSandyaWorkExp1')}
                                            </span>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="inline-block w-2 h-2 bg-amber-500 rounded-full mt-2 mr-3 flex-shrink-0" />
                                            <span className="text-teal-900/80 text-sm md:text-base">
                                                {t('drSandyaWorkExp2')}
                                            </span>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="inline-block w-2 h-2 bg-amber-500 rounded-full mt-2 mr-3 flex-shrink-0" />
                                            <span className="text-teal-900/80 text-sm md:text-base">
                                                {t('drSandyaWorkExp3')}
                                            </span>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="inline-block w-2 h-2 bg-amber-500 rounded-full mt-2 mr-3 flex-shrink-0" />
                                            <span className="text-teal-900/80 text-sm md:text-base">
                                                {t('drSandyaWorkExp4')}
                                            </span>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="inline-block w-2 h-2 bg-amber-500 rounded-full mt-2 mr-3 flex-shrink-0" />
                                            <span className="text-teal-900/80 text-sm md:text-base">
                                                {t('drSandyaWorkExp5')}
                                            </span>
                                        </li>
                                    </ul>
                                </div>

                                {/* Education */}
                                <div>
                                    <h4 className="text-sm uppercase tracking-wider font-semibold text-amber-600 mb-3">
                                        {t('drSandyaEducationTitle')}
                                    </h4>
                                    <ul className="space-y-2">
                                        <li className="flex items-start">
                                            <span className="inline-block w-2 h-2 bg-teal-600 rounded-full mt-2 mr-3 flex-shrink-0" />
                                            <span className="text-teal-900/80 text-sm md:text-base">
                                                {t('drSandyaEdu1')}
                                            </span>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="inline-block w-2 h-2 bg-teal-600 rounded-full mt-2 mr-3 flex-shrink-0" />
                                            <span className="text-teal-900/80 text-sm md:text-base">
                                                {t('drSandyaEdu2')}
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </motion.div>

                        {/* Dr. Panduka Card */}
                        <motion.div
                            variants={{
                                hidden: { opacity: 0, y: 50 },
                                visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut", delay: 0.2 } }
                            }}
                            className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500"
                        >
                            {/* Doctor Image */}
                            <div className="relative h-80 md:h-96 lg:h-[28rem] xl:h-[32rem] overflow-hidden">
                                <img
                                    src={drPandukaImg}
                                    alt={t('drPandukaName')}
                                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-teal-950/80 via-transparent to-transparent" />
                                <div className="absolute bottom-6 left-6 text-white">
                                    <h3 className="text-2xl md:text-3xl font-serif font-semibold mb-1">
                                        {t('drPandukaName')}
                                    </h3>
                                    <p className="text-amber-200 text-lg md:text-xl">
                                        {t('drPandukaProfession')}
                                    </p>
                                </div>
                            </div>

                            {/* Doctor Details */}
                            <div className="p-6 md:p-8 space-y-6">
                                {/* Qualification */}
                                <div>
                                    <h4 className="text-sm uppercase tracking-wider font-semibold text-amber-600 mb-2">
                                        Qualification
                                    </h4>
                                    <p className="text-teal-900 text-base md:text-lg leading-relaxed">
                                        {t('drPandukaQualification')}
                                    </p>
                                </div>

                                {/* Professional Profile */}
                                <div>
                                    <h4 className="text-sm uppercase tracking-wider font-semibold text-amber-600 mb-2">
                                        {t('drPandukaProfileTitle')}
                                    </h4>
                                    <p className="text-teal-900/80 text-base leading-relaxed">
                                        {t('drPandukaProfile')}
                                    </p>
                                </div>

                                {/* Professional Expertise */}
                                <div>
                                    <h4 className="text-sm uppercase tracking-wider font-semibold text-amber-600 mb-2">
                                        {t('drPandukaExpertiseTitle')}
                                    </h4>
                                    <p className="text-teal-900/80 text-base leading-relaxed">
                                        {t('drPandukaExpertise')}
                                    </p>
                                </div>

                                {/* Integrative Therapies */}
                                <div>
                                    <h4 className="text-sm uppercase tracking-wider font-semibold text-amber-600 mb-2">
                                        {t('drPandukaSpecialtyTitle')}
                                    </h4>
                                    <p className="text-teal-900/80 text-base leading-relaxed">
                                        {t('drPandukaSpecialty')}
                                    </p>
                                </div>

                                {/* Commitment to Excellence */}
                                <div>
                                    <h4 className="text-sm uppercase tracking-wider font-semibold text-amber-600 mb-2">
                                        {t('drPandukaRoleTitle')}
                                    </h4>
                                    <p className="text-teal-900/80 text-base leading-relaxed">
                                        {t('drPandukaRole')}
                                    </p>
                                </div>
                            </div>
                        </motion.div>

                    </div>
                </div>
            </motion.section>

            {/* ===== AYURVEDA TREATMENT PROGRAMME SECTION ===== */}
            <motion.section
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: "-80px" }}
                variants={{
                    hidden: { opacity: 0 },
                    visible: {
                        opacity: 1,
                        transition: { staggerChildren: 0.18, delayChildren: 0.3 }
                    }
                }}
                className="relative py-16 md:py-24 lg:py-32 bg-gradient-to-b from-[#f9f7f0] via-[#f5f2e8] to-[#e8e4d6] overflow-hidden"
            >
                {/* Subtle decorative background glows */}
                <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute top-20 right-10 w-64 h-64 md:w-96 md:h-96 bg-amber-500/5 rounded-full blur-3xl" />
                    <div className="absolute bottom-10 left-10 w-64 h-64 md:w-96 md:h-96 bg-teal-600/5 rounded-full blur-3xl" />
                </div>

                <div className="relative container mx-auto px-5 sm:px-8 lg:px-12">
                    {/* Header */}
                    <motion.div
                        variants={{
                            hidden: { opacity: 0, y: 40 },
                            visible: { opacity: 1, y: 0, transition: { duration: 0.9, ease: "easeOut" } }
                        }}
                        className="text-center mb-14 md:mb-20"
                    >
                        <span className="
        inline-block text-amber-600 uppercase tracking-[0.35em] md:tracking-[0.5em]
        text-sm md:text-base font-medium mb-4
      ">
                            Your Personalized Healing Journey
                        </span>

                        <h2 className="
        text-3xl sm:text-4xl md:text-5xl lg:text-6xl
        font-serif font-light text-teal-950 tracking-tight
      ">
                            Ayurveda Treatment Programme
                        </h2>

                        <p className="
        mt-5 text-xl md:text-2xl lg:text-3xl
        font-medium text-amber-600/90 max-w-4xl mx-auto leading-relaxed
      ">
                            Your Journey to Balance, Detox & Deep Renewal
                        </p>

                        <div className="h-1 w-20 md:w-28 mx-auto mt-6 bg-gradient-to-r from-amber-500 to-teal-700 rounded-full" />
                    </motion.div>

                    {/* Introductory Paragraph */}
                    <motion.p
                        variants={{
                            hidden: { opacity: 0, y: 30 },
                            visible: { opacity: 1, y: 0, transition: { delay: 0.2, duration: 0.8 } }
                        }}
                        className="
        text-center text-lg md:text-xl lg:text-2xl
        text-teal-800/90 leading-relaxed max-w-4xl mx-auto mb-16 md:mb-20
        font-light
      "
                    >
                        Experience authentic Ayurvedic healing in a peaceful beachfront retreat designed to restore your body, calm your mind, and renew your energy. From the moment you arrive, our dedicated team takes care of every detail—so you can fully surrender to your wellbeing.
                    </motion.p>

                    {/* Programme Timeline / Blocks */}
                    <div className="max-w-5xl mx-auto space-y-10 md:space-y-16">
                        {[
                            {
                                title: "Welcome & Gentle Start",
                                items: [
                                    "Airport pick-up and private transfer to the resort",
                                    "Warm traditional welcome and resort orientation",
                                    "Introduction to your personalized weekly wellness schedule",
                                    "Relaxation Massage (Day 1) to release travel fatigue and prepare your body"
                                ]
                            },
                            {
                                title: "Doctor Consultation & Personalized Plan",
                                items: [
                                    "Detailed Ayurvedic consultation with our experienced doctor (Day 2 – morning)",
                                    "Comprehensive assessment of your Dosha (body constitution), pulse diagnosis & health concerns",
                                    "Professional translator available upon request",
                                    "Customized treatment plan created specifically for your needs, goals and current condition"
                                ]
                            },
                            {
                                title: "Daily Ayurveda Therapies",
                                items: [
                                    "4–5 therapeutic treatments per day (as prescribed by your doctor)",
                                    "Therapies carefully selected based on your unique body type and health requirements",
                                    "Specialized massages and therapies added when beneficial",
                                    "Daily progress monitoring by the doctor with possible adjustments to treatments or herbal support",
                                    "Gentle cleansing or eliminative procedures recommended only when appropriate"
                                ]
                            },
                            {
                                title: "Herbal Medicine Support",
                                items: [
                                    "Doctor-prescribed authentic Ayurvedic herbal medicines served twice daily:",
                                    "During breakfast",
                                    "During dinner",
                                    "Formulations support internal healing, gentle detoxification and long-term balance"
                                ]
                            },
                            {
                                title: "Yoga & Meditation for Mind–Body Harmony",
                                items: [
                                    "Yoga sessions 4 times per week (approximately 1 hour each)",
                                    "Meditation sessions 2 times per week, including:",
                                    "A unique spiritual meditation experience at a serene island temple (reached by traditional boat)",
                                    "Guided meditation led by experienced monks (approx. 1 hour)"
                                ]
                            },
                            {
                                title: "Included Wellness & Cultural Experiences",
                                items: [
                                    "Weekly healthy Ayurvedic cookery demonstrations",
                                    "One complimentary cultural or nature excursion (depending on season and availability)"
                                ]
                            },
                            {
                                title: "Closing Ritual & Harmonious Departure",
                                items: [
                                    "Beautiful traditional Flower Bath on your final day – a symbolic ritual of renewal and gratitude",
                                    "Final consultation with your doctor to review progress and receive:",
                                    "Continued wellness guidance for home",
                                    "Personalized prescriptions and recommendations",
                                    "Private transfer back to the airport"
                                ]
                            }
                        ].map((block, index) => (
                            <motion.div
                                key={block.title}
                                custom={index}
                                variants={{
                                    hidden: { opacity: 0, y: 30 },
                                    visible: i => ({
                                        opacity: 1,
                                        y: 0,
                                        transition: { delay: i * 0.12, duration: 0.7, ease: "easeOut" }
                                    })
                                }}
                                className="
            relative pl-8 md:pl-12
            border-l-4 border-amber-500/70 hover:border-amber-600
            transition-colors duration-300
          "
                            >
                                <div className="absolute -left-3 md:-left-4 top-0 w-6 h-6 md:w-8 md:h-8 rounded-full bg-gradient-to-br from-amber-500 to-amber-700 flex items-center justify-center text-white font-bold text-sm md:text-base shadow-md">
                                    {index + 1}
                                </div>

                                <h3 className="
            text-2xl md:text-3xl lg:text-4xl font-serif font-light
            text-teal-950 mb-5 md:mb-6
          ">
                                    {block.title}
                                </h3>

                                <ul className="space-y-4 md:space-y-5">
                                    {block.items.map((item, i) => (
                                        <li
                                            key={i}
                                            className="
                  flex items-start gap-4 text-lg md:text-xl
                  text-teal-800/90 leading-relaxed
                "
                                        >
                                            <span className="text-amber-500 text-2xl mt-0.5 flex-shrink-0">•</span>
                                            <span>{item}</span>
                                        </li>
                                    ))}
                                </ul>
                            </motion.div>
                        ))}
                    </div>

                    {/* Final CTA */}
                    <motion.div
                        variants={{
                            hidden: { opacity: 0, y: 40 },
                            visible: { opacity: 1, y: 0, transition: { delay: 1.2, duration: 0.9 } }
                        }}
                        className="text-center mt-16 md:mt-24"
                    >
                        <a
                            href="/contact-us"
                            className="
          inline-flex items-center gap-4 px-10 py-5 md:px-12 md:py-6
          rounded-full bg-gradient-to-r from-amber-500 to-amber-600
          hover:from-amber-600 hover:to-amber-700
          text-white font-semibold text-lg md:text-xl
          shadow-xl hover:shadow-2xl transform hover:-translate-y-1
          transition-all duration-300
        "
                        >
                            Begin Your Healing Journey Today
                            <span aria-hidden className="text-xl">→</span>
                        </a>
                    </motion.div>
                </div>
            </motion.section>



        </div>
    );
};

export default Ayurveda;